import { Box, Skeleton } from '@chakra-ui/react';
import assert from 'assert';
import _ from 'lodash';
import React from 'react';

import { CreditFacilityBankAccountsContainer } from 'borrower/domains/bankAccounts/ui/CreditFacilityAccountsContainer';
import { PageHeader } from 'packages/common-frontend/components/PageContainer';
import { useGetCreditFacilitiesQuery } from 'packages/credit-facility/requests/requests.gql.generated';

export const BankAccountsViewContainer = ({
  borrowerKey,
  borrowerId,
}: {
  borrowerKey: string;
  borrowerId: string;
}) => {
  const {
    data: creditFacilitiesForBorrowerData,
    loading: creditFacilitiesForBorrowerLoading,
  } = useGetCreditFacilitiesQuery({
    variables: { organizationId: borrowerId },
  });

  if (
    creditFacilitiesForBorrowerLoading ||
    !creditFacilitiesForBorrowerData ||
    !creditFacilitiesForBorrowerData.creditFacilities
  ) {
    return <Skeleton data-testid="loading-bank-accounts" height="600px" />;
  }

  assert(
    creditFacilitiesForBorrowerData.creditFacilities.length > 0,
    `Borrower ${borrowerKey} should have at least one existing credit facility`,
  );

  return (
    <Box>
      <PageHeader headerLabel="Bank accounts" marginBottom="30px" />
      {_.map(
        creditFacilitiesForBorrowerData.creditFacilities,
        (creditFacility, idx) => {
          return (
            <CreditFacilityBankAccountsContainer
              borrowerId={borrowerId}
              creditFacilityId={creditFacility.id}
              creditFacilitySlug={creditFacility.slug}
              creditFacilityNumber={idx + 1}
              key={creditFacility.id}
            />
          );
        },
      )}
    </Box>
  );
};
